import React from 'react';
import styles from './ConfColorPicker.module.less';
import AbstractPicker, { connect } from '../AbstractPicker';
import { translate } from '../../../services/L10n';
import { t } from '../../../translations';
import CircleOption from '../../CircleOption';

const sortOrder = {
  insert: [
    'black_mesh',
    'mesh_white',
    'metal_white',
    'metal_anthracite',
    'wire_white',
    'wire_anthracite',
    'black',
    'grey_green',
    'wood',
    'white',
    'anthracite',
    'grey',
    'oak',
    'dark_grey',
    'bamboo',
  ],
  section: ['wood', 'black', 'grey_green', 'white', 'dark_grey'],
  item: [
    'black_mesh',
    'mesh_white',
    'black',
    'grey_green',
    'wood',
    'white',
    'anthracite',
    'dark_grey',
    'light_blue',
    'white_stained_oak_effect',
    'black_brown',
    'bamboo',
  ],
};

class ConfColorPicker extends AbstractPicker {
  state = {
    options: [],
  };

  tooltips = {
    white: translate(t.TOOLTIP_WHITE),
    red: translate(t.TOOLTIP_RED),
    wood: translate(t.TOOLTIP_WOOD),
    metal_white: `${translate(t.TOOLTIP_METAL)}/${translate(t.TOOLTIP_WHITE)}`,
    metal_anthracite: `${translate(t.TOOLTIP_METAL)}/${translate(
      t.TOOLTIP_ANTHRACITE
    )}`,
    black: translate(t.TOOLTIP_BLACK),
    wire_anthracite: `${translate(t.TOOLTIP_WIRE_SHELF)}/${translate(
      t.TOOLTIP_ANTHRACITE
    )}`,
    grey_green: translate(t.TOOLTIP_GREY_GREEN),
    wire_white: `${translate(t.TOOLTIP_WIRE_SHELF)}/${translate(
      t.TOOLTIP_WHITE
    )}`,
    oak: translate(t.TOOLTIP_OAK_PATTERNED),
    white_stained_oak_effect: translate(t.TOOLTIP_WHITE_OAK),
    light_blue: translate(t.TOOLTIP_LIGHT_BLUE),
    grey: translate(t.TOOLTIP_GREY),
    anthracite: translate(t.TOOLTIP_ANTHRACITE),
    dark_grey: translate(t.TOOLTIP_DARK_GREY),
    black_brown: translate(t.TOOLTIP_BLACKBROWN),
    mesh_grey: translate(t.TOOLTIP_GREY_MESH),
    mesh_white: translate(t.TOOLTIP_MESH),
    mesh_green: translate(t.TOOLTIP_GREEN_MESH),
    grey_green_mesh: translate(t.TOOLTIP_GREY_GREEN_MESH),
    black_mesh: translate(t.TOOLTIP_BLACK_MESH),
    pine: translate(t.TOOLTIP_PINE),
    bamboo: translate(t.TOOLTIP_BAMBOO),
  };

  itemsAsOptions() {
    const colorOptions = new Set();
    return this.props.items
      .map(item => ({
        value: item.filter.color,
        id: item.id,
        type: item.filter.type,
      }))
      .reduce((options, currentOption) => {
        if (!colorOptions.has(currentOption.value)) {
          colorOptions.add(currentOption.value);
          options.push(currentOption);
        }
        return options;
      }, [])
      .sort((a, b) => {
        if (sortOrder[this.props.sortOrder]) {
          return (
            sortOrder[this.props.sortOrder].indexOf(a.value) -
            sortOrder[this.props.sortOrder].indexOf(b.value)
          );
        }
        return 1;
      });
  }

  render() {
    const options = this.itemsAsOptions();
    const selected = this.props.selected;
    return (
      <div className={styles['outer-wrapper']}>
        {this.props.showHeadline && (
          <div className={styles.headline}>{translate(t.COLOUR)}:</div>
        )}
        <div className={styles['inner-wrapper']}>
          <div className={styles.container}>
            {options.map((option, index) => (
              <CircleOption
                key={index}
                type={this.props.item.filter.type}
                name={option.value}
                selected={this.isSelected(option, selected, 'color')}
                onClick={() =>
                  this.switch({
                    from: this.props.item,
                    to: option,
                    switchingProp: 'color',
                    targetType: this.props.targetType,
                  })
                }
                tooltipContent={this.tooltips?.[option.value]}
                dataTestId={`color-picker-${index}`}
              />
            ))}
          </div>
        </div>
      </div>
    );
  }
}

export default connect(ConfColorPicker);
